import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import {
  DokaApp,
  DokaContent,
  DokaFooter,
  DokaFooterInfo,
  DokaFooterLink,
  DokaHeader,
  DokaUserContextMenu,
  DokaUserContextMenuEntry,
  PlatformService,
  VcrDirective,
  DokaMenu,
  DokaMenuItem,
  DokaCustomHeaderAction,
  DokaLanguageContextMenu,
  DokaNavbar,
  DokaNavbarItem,
  DokaAppSelect,
} from '@doka/angular-core';
import { I18NextEagerPipe } from 'angular-i18next';
import { APP_ROOT } from './injectionTokens/app-root';
import { environment } from '../environments/environment';
import { DokaI18NextService } from '@doka/i18next';
import { DokaIdentityLoginService } from '@doka/identity-login';
import { FormsModule } from '@angular/forms';
import { DotBranchSelection } from '@dot/core';

@Component({
  selector: 'return-root',
  templateUrl: 'app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonApp,
    IonRouterOutlet,
    I18NextEagerPipe,
    DokaHeader,
    DokaUserContextMenu,
    DokaUserContextMenuEntry,
    DokaApp,
    DokaContent,
    VcrDirective,
    DokaFooter,
    DokaFooterLink,
    DokaFooterInfo,
    DokaMenu,
    DokaMenuItem,
    FormsModule,
    DokaCustomHeaderAction,
    DotBranchSelection,
    DokaLanguageContextMenu,
    DokaNavbar,
    DokaNavbarItem,
    RouterOutlet,
    DokaAppSelect,
  ],
})
export class App {
  public environment = environment;
  public rootPath = inject(APP_ROOT);

  public mobileRoot = 'return';
  public webRoot = 'return';

  protected readonly isNavbarOpen = signal(false);

  constructor(
    protected dokaTranslation: DokaI18NextService,
    protected loginService: DokaIdentityLoginService,
    protected platformService: PlatformService,
  ) {
  }
}
